module.exports = __webpack_public_path__ + "@/assets/img/group-chat.be62916a.svg";